import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { LoaderDots as LoaderDotsComponent } from './Loader';
LoaderDotsComponent.displayName = 'LoaderDots';
export var LoaderDots = withProvisionalOverrideFromContext(LoaderDotsComponent);
//# sourceMappingURL=index.js.map